var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 48,
    cx: 48,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#ccc",
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 48,
    cx: 48,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#fff",
    r: 34
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 9,
    stroke: "#ccc",
    fill: "none",
    d: "M48 22v26m17 0H43.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusScheduled);
export default __webpack_public_path__ + "static/media/status-scheduled.50de35de31cdc4b6052afef1e3b2dc6d.svg";
export { ForwardRef as ReactComponent };